import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'antd';
import Modal from '@/components/common/modal';
import Button from '@/components/common/button';
import './index.scss';
import '../style.scss';
import { useDispatch } from 'react-redux';
import { createCustomer } from '@/store/actions/customer';
import {
  requestAddCustomerAddressApi,
  requestCreateCustomerProfilePictureApi,
} from '@/store/requests/customer';
import CustomerProfilePicture from '@/components/customer/component/ProfilePicture';
import { ICON } from '@/components/common/icon/iconFlag';
import { showMessageFailed } from '@/utils';
import PersonalInformation from '@/components/customer/detail/infomation/personalInfo';
import AddressInformation from '@/components/customer/detail/infomation/addressInformation';

export default ({ isOpen = false, onCloseProp }) => {
  const dispatch = useDispatch();

  const [avatar, setAvatar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    setValues({});
    setAvatar(null);
    setLoading(false);
  }, [isOpen]);

  const save = async () => {
    try {
      setLoading(true);
      const { confirmPassword, shipping_addresses, ...data } = await form.validateFields();
      dispatch(
        createCustomer(
          {
            ...data,
            country_code: data.mobile_phone.country.toUpperCase(),
            mobile_phone: `${data.mobile_phone.code}${data.mobile_phone.number}`,
          },
          async (isOk, user) => {
            if (isOk) {
              onCloseProp();
              try {
                await requestAddCustomerAddressApi({
                  guid: user.guid,
                  params: shipping_addresses,
                });
              } catch (error) {
                showMessageFailed({ error });
              }
              if (avatar?.originFileObj)
                try {
                  await requestCreateCustomerProfilePictureApi({
                    guid: user.guid,
                    file: avatar.originFileObj,
                  });
                } catch (error) {
                  showMessageFailed({ error });
                }
            }
            setLoading(false);
          },
        ),
      );
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Customer"
      open={isOpen}
      onClose={onCloseProp}
      destroyOnClose
      width="80%"
      className="add-customer"
    >
      <Row className="content">
        <Col span={8} className="left">
          <p>Profile picture</p>
          <CustomerProfilePicture value={avatar?.preview} onChange={setAvatar} />
        </Col>

        <Col span={16} className="right">
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(_, value) => setValues(value)}
            initialValues={values}
            className="customer-form form"
          >
            <p className="title">Personal Information</p>

            <PersonalInformation values={values} form={form} />

            <AddressInformation values={values} form={form} />

            <div className="actions">
              <Button
                type="primary"
                size="large"
                onClick={form.resetFields}
                fixedIcon
                flagIcon={ICON.ICONS_CLEAR}
                className="btn-clear btn"
              >
                Clear
              </Button>
              <div />
              <Button
                type="primary"
                fixedIcon
                flagIcon={ICON.ICONS_REFUND}
                className="btn-back btn"
                onClick={onCloseProp}
              >
                Back
              </Button>
              <Button
                type="primary"
                fixedIcon
                flagIcon={ICON.ICONS_SAVE_SOLID}
                className="btn-save btn"
                onClick={save}
                loading={loading}
              >
                Save
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};
